/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var HeaderIcon = createIcon("HeaderIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#333';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "14",
    height: "13",
    viewBox: "0 0 14 13"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: _color,
    opacity: ".8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.517 6.154v6.492H2.05V6.154H0V4.847h5.556v1.307z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.767 2.03v10.616H7.964V2.03H4.575V.39h8.548v1.64z"
  })));
}, {
  "replaceColor": true
});